export default function (text) {
    const ts = Date.parse(text);
    if (isNaN(ts)) return '-';
    const date = new Date(ts);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
};
